export enum GEGSystemType {
    New = 'NEW',
    Current = 'CURRENT',
    Hybrid = 'HYBRID'
}
